import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

export function useSettingsApi() {
  const { apiFetch } = useAuth();

  return useMemo(
    () => ({
      getAll: () => apiFetch("/settings"),

      update: (data) =>
        apiFetch(`/settings`, {
          method: "PUT",
          body: JSON.stringify(data),
        }),

      testEmail: (to) =>
        apiFetch("/settings/email/test", {
          method: "POST",
          body: JSON.stringify({ to }),
        }),

      googleStatus: () => apiFetch("/settings/google/status"),

      googleAuthUrl: () => apiFetch("/settings/google/auth-url"),

      googleSync: (payload = {}) =>
        apiFetch("/settings/google/sync", {
          method: "POST",
          body: JSON.stringify(payload),
        }),

      listPm2: () => apiFetch("/settings/pm2"),

      restartPm2: (target) =>
        apiFetch("/settings/pm2/restart", {
          method: "POST",
          body: JSON.stringify({ target }),
        }),
    }),
    [apiFetch],
  );
}
